import React from 'react';
import language from '../../../assets/languages/language';

function CBTTotalScore(props) {
  const { rightAnswerCount, totalQuestions: outOfScore } = props;
  let percentage = (rightAnswerCount * 100) / outOfScore;
  return (
    <div className='score-wrapper'>
      <div className='score-inner'>
        {rightAnswerCount ? rightAnswerCount : 0}/{outOfScore}
      </div>
      <h5>{language.LC().TOTAL_SCORE}</h5>
      <h5>
        {language.LC().You_Scored} {Math.ceil(percentage)}%
      </h5>
    </div>
  );
}

export default CBTTotalScore;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/CBTTotalScore.jsx